// extracted by css-extract-rspack-plugin
export default {"cls1":"Attachment-cls1_3cD","cls2":"Attachment-cls2_LXj Attachment-cls1_3cD"};